import styled from 'styled-components';
import {FULL_SCREEN} from '@/styles';

export const FullContainer = styled.div`
  width: ${FULL_SCREEN.vw};
  height: ${FULL_SCREEN.vh};
  position: relative;
  display: flex;
  flex-grow: 1;
`;

export const HorizontalFullContainer = styled(FullContainer)`
  flex-direction: column;
`;

export const ScrollBody = styled.div`
  width: 100%;
  padding: 24px 16px;
  flex-grow: 1;
  overflow: auto;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 328px;
  margin: auto;
`;

export const PageContentWide = styled(PageContent)`
  max-width: 600px;
`;
